/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StatusResponseDto { 
    /**
     * Status id
     */
    id?: string;
    /**
     * Mongo status id
     */
    _id?: string;
    /**
     * Status display value
     */
    value: string;
    /**
     * Status key
     */
    key: string;
    /**
     * Status type tags
     */
    type?: Array<string>;
    /**
     * Created date
     */
    createdAt?: string;
    /**
     * Updated date
     */
    updatedAt?: string;
    /**
     * Deleted date
     */
    deletedAt?: string | null;
}

